import { ItemProgressKey } from '@shared/model/project';

export interface IBreadcrumb extends ILink {
  children?: ILink[];
}

export interface ILink {
  link: string;
  text: string;
  progressName?: ItemProgressKey;
}
